import { Slider } from "../../components/slider.js";
import { LoadingDot } from "../../components/loading-dot.js";
import { LoadingLine } from "../../components/loading-line.js";
import { ItemsModel } from "./model.js";
import { ItemsView } from "./view.js?v=1";
import { BannersController } from "../banners/controller.js";
import { USER_OPTIONS } from "../../config/constants.js";
import { ItemsViewUserInfo } from "./view.js";

export class ItemsController {
  constructor() {
    this.data = [];
    this.dom = document.getElementsByClassName('items')[0];
    this.model = new ItemsModel();
    this.view = new ItemsView();
    this.loadingLine = LoadingLine.getInstance();
    this.banners = BannersController.getInstance();
  }

  async init(_scroll, _entity, _title) {
    return await new Promise(async (resolve, reject) => {
      this.loadingLine.show();
      this.dom.innerHTML = LoadingDot.render();
      if (_entity == '') {
        this.data = await this.model.loadAll();
      } else {
        this.data = await this.model.load(_entity);
      }
      this.showItemsInContainer(this.data, _title);
      window.localStorage.setItem('last-items', JSON.stringify(this.data));
      if (_scroll === true) {
        this.scroll();
      }
      this.loadingLine.hide();
      resolve(this.data);
    });
  }

  scroll() {
    setTimeout(() => {
      this.dom.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 200);
  }


  search(param) {
    if (param !== null && param !== undefined && param !== '') {
      param = param.trim();
      this.dom.innerHTML = `<div><h3>Buscando${LoadingDot.render()}<h3></div>`;
      // this.Scroll();
      this.loadingLine.show();
      this.model.search(['titulo', 'resumen', 'descripcion'], param, 'asc')
        .then(_data => {
          document.getElementById('search-title').removeAttribute('style');
          // document.getElementById('order').removeAttribute('style');
          document.getElementById('search-title').innerHTML = `<h1>Resultados para <b>${param}</b></h1>`;
          this.showItemsInContainer(_data);
        })
        .catch(() => {
          document.getElementById('search-title').setAttribute('style', 'display: none');
          // document.getElementById('order').setAttribute('style', 'display: none');
          this.dom.innerHTML = `
            <div>
              <h1 style="margin-bottom:0px">No hay resultados para:</h1>
              <h1><b style="color: var(--verde3);">${param}</b></h1>
              <button onclick="window.location.href='/'">Volver a todos los servicios</button>
            </div>`;
        })
        .finally(() => {
          this.loadingLine.hide();
        });
    } else {
      this.init(true);
    }
  }

  searchKey(_event) {
    if (_event && _event.keyCode == 13) {
      this.searchUrl();
    }
  }

  searchUrl() {
    let param = document.getElementById('search-input')?.value.trim() || '';
    if (window.innerWidth < 600) {
      param = document.getElementById('search-input-mobile')?.value.trim() || '';
    }
    if (param !== null && param !== undefined && param !== '' && param.length > 2) {
      window.location.href = '/search/' + param.replace(/ /g, '-');
    }
  }

  PostLoad(_items) {
    // Lanzamos todos los sliders
    setTimeout(() => {
      for (let i = 0; i < _items.length; i++) {
        new Slider('slider-' + _items[i].idcod, _items[i].imagenes, false, false, _items[i].titulo);
        new ItemsViewUserInfo(_items[i].idcodUserCreate, _items[i].titulo, _items[i].user_deleted);
      }
    }, 200);

  }

  async showItemsInContainer(_items, _title) {
    if (_title && document.getElementById('main-titulo')) {
      document.getElementById('main-titulo').innerHTML = _title;
    }
    this.dom.innerHTML = this.view.renderCollection(_items);

    this.PostLoad(_items);
  }

  async showItemDetail(_idcod, _title) {
    let dom = document.getElementsByClassName('item-main-container')[0];
    // dom.innerHTML = LoadingDot.render();
    this.loadingLine.show();

    let tipo = '';
    let entity = '';
    if (window.location.pathname.indexOf('/productos/') > -1) {
      tipo = '1'
      entity = 'producto';
    } else if (window.location.pathname.indexOf('/maquinaria/') > -1) {
      tipo = '2'
      entity = 'maquina';
    } else if (window.location.pathname.indexOf('/inmuebles/') > -1) {
      tipo = '3'
      entity = 'inmueble';
    } else if (window.location.pathname.indexOf('/servicios/') > -1) {
      tipo = '4'
      entity = 'servicio';
    }

    this.model.GetItem(_idcod, entity)
      .then(async _data => {
        this.banners.hide();

        _data.tipo = tipo;
        _data = this.model.getTypes(_data);
        // _data.user = await app.userPrivateController.auth.getInfoUserFromIdcod(_data.idcodUser);
        // _data.user.occupation = USER_OPTIONS.Cargos.find(i => i.value == _data.user.occupation)?.text || '';

        dom.innerHTML = this.view.renderItemDetail(_data);
        setTimeout(() => {
          new Slider('slider-' + _data.idcod, _data.imagenes, true, true, _data.titulo);
          new ItemsViewUserInfo(_data.idcodUserCreate, _data.titulo, _data.user_deleted);
          window.InitButtonToProvider();
        }, 200);

        // LOAD SIMILAR
        this.model.search(['titulo', 'descripcion'], _data.titulo.split(' '), 'DESC', 3)
          .then(_items => {
            if (_items.length > 1) {
              return _items;
            } else {
              document.getElementById('similares-titulo').innerHTML = 'Otras publicaciones';
              let ultimos = JSON.parse(window.localStorage.getItem('last-items'));
              return [ultimos[0], ultimos[1], ultimos[2], ultimos[3], ultimos[4]];
            }
          })
          .then(_items => {
            let newItems = [];
            for (let i = 0; i < _items.length; i++) {
              if (_items[i].idcod !== _data.idcod) {
                newItems.push(_items[i]);
              }
            }
            return newItems;
          })
          .then(_items => {
            document.getElementById('similares').innerHTML = this.view.renderCollection(_items);
            this.PostLoad(_items);
          })
          .catch(_error => {
            console.log(_error);
          });

      })
      .catch(_error => {
        console.error(_error);
        dom.innerHTML = `
            <div>
              <h1 style="margin-bottom:0px">No se pudo cargar el servicio:</h1>
              <h1><b style="color: var(--verde3);">${_title}</b></h1>
              <button onclick="window.location.href='/'">Ver más servicios</button>
            </div>`;
      })
      .finally(() => {
        this.loadingLine.hide();
      });
  }

}
